module.exports = __webpack_public_path__ + "static/8-d965a89cb2a81ea260de8b7e0307352c.png";